<template>
  <div>
    <h5 style="text-align: center;">撤销上传操作--证明开具</h5>
    <el-table :data="logs" style="width: 100%">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="datetime_cn" label="上传时间"></el-table-column>
      <el-table-column prop="uuid" label="uuid"></el-table-column>
      <el-table-column label="Operations">
        <template #default="scope">
          <el-button type="danger" size="mini" @click="confirmDelete(scope.row.uuid)">撤销</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';

export default {
  name: 'App',
  data() {
    return {
      logs: [],
    };
  },
  methods: {

    // === 将 yyyy-mm-dd hh:mm:ss 转中文格式 ===
    formatChineseDatetime(dtString) {
      const dt = new Date(dtString);
      if (isNaN(dt.getTime())) return dtString; // 防止错误

      const Y = dt.getFullYear();
      const M = String(dt.getMonth() + 1).padStart(2, "0");
      const D = String(dt.getDate()).padStart(2, "0");

      const h = String(dt.getHours()).padStart(2, "0");
      const m = String(dt.getMinutes()).padStart(2, "0");
      const s = String(dt.getSeconds()).padStart(2, "0");

      return `${Y}年${M}月${D}日 ${h}:${m}:${s}`;
    },

    // === 获取上传记录 ===
    fetchLogs() {
      axios.get('/api/logs')
        .then(response => {
          this.logs = response.data.map(item => ({
            ...item,
            datetime_cn: this.formatChineseDatetime(item.datetime)
          }));
        })
        .catch(error => ElMessage.error("获取失败：" + error));
    },

    confirmDelete(uuid) {
      ElMessageBox.confirm(
        '确定要撤销这条记录吗？',
        '确认撤销',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.deleteLog(uuid);
      }).catch(() => {
        ElMessage.info('撤销操作已取消');
      });
    },

    deleteLog(uuid) {
      axios.delete(`/api/logs/${uuid}`)
        .then(() => {
          this.fetchLogs();
          ElMessage.success('撤销成功');
        })
        .catch(error => {
          ElMessage.error(`撤销失败: ${error.message}`);
        });
    },
  },

  mounted() {
    this.fetchLogs();
  },
};
</script>
